import { Rule, SDateEDate } from "src/app/reusables/models/rule.model";

export interface GamesDataByLogin {
    openGames: GameObject[];
    currentGames: GameObject[];
    endedGames: GameObject[];
    rewards: GameActionObject;
}

export interface GameActionObject {
    game: GameObject;
    actionIds: number[];
    coins: number;
    XP: number;
    badges: number;
    expirationDate: string;
}

export class GameObject {
    underlyingRule: Rule;
    MultiplierMadnessRewards: MultiplierMadnessRewards;
    TopDogRewards: TopDogRewards[];
    BullseyeRewards: BullseyeRewards[];
    Connect3Rewards: ConnectRewards;
    Connect3Positions: ConnectPositions[];
    MilestoneRewards: MilestoneRewards[];
    MilestoneDetails: MilestoneDetails;
    SelectedMetrics: SelectedMetric[];
    Qualifier: SelectedMetric;
    QualifierLevels: QualifierLevel;
    Eligibility: Eligibility;
    Schedule: Schedule;
    RemovedRuleLevelIDs: number[];
    Intervals: SDateEDate[];
    iconClass: string = "gtiMultiplierMadness";
    gameTypeName: string = "";
    isActive: boolean = true;
    isActiveText: string = "Continuously Running";
    isRunning: boolean = true;
    earnedCoins: number = 0;
    earnedBadges: number[] = [];
}

export interface GameReward {
    rewardType: number;
    rewardValue: number;
}

export interface GameTarget {
    Val1: number;
    Val2: number;
}

export interface MultiplierMadnessRewards {
    coins: number;
    xp: number;
    currency: number;
    maxCoinsPayout: number;
    maxXpPayout: number;
    maxCurrencyPayout: number;
    hasMaxCoins: boolean;
    hasMaxXP: boolean;
    hasMaxCurrency: boolean;
}

export interface TopDogRewards {
    Coins: GameReward;
    XP: GameReward;
    Badge: GameReward;
    RuleLevelID: number;
} 

export interface BullseyeRewards {
    Target: GameTarget;
    Coins: GameReward;
    XP: GameReward;
    Currency: GameReward;
    Badge: GameReward;
    ComparisonType: number;
    RuleLevelID: number;
    RemovedRuleLevelIDs: number[];
}

export interface ConnectRewards {
    ThreeInRow: ConnectReward;
    Blackout: ConnectReward;
}

export interface ConnectReward {
    coins: number;
    xp: number;
    badge: number;
}

export interface ConnectPositions {
    position: number;
    metric: SelectedMetric;
    targetObj: ConnectMetricTarget;
}

export interface ConnectMetricTarget {
    MetricID: number;
    Target: number;
    RangedTarget: number;
    Direction: number;
}

export interface MilestoneRewards {
    Target: GameTarget;
    Coins: GameReward;
    XP: GameReward;
    Currency: GameReward;
    Badge: GameReward;
    ComparisonType: number;
    RuleLevelID: number;
    RemovedRuleLevelIDs: number[];
}

export interface MilestoneDetails {
    MilestoneQty: number;
    MilestoneThemeSelected: MilestoneTheme;
}

export interface MilestoneTheme {
    themeID: number;
    themeName: string;
    themePath: string;
}

export interface SelectedMetric {
    metricID: number;
    abbrev: string;
    name: string;
    prefix: string;
    suffix: string;
    conversionType: string;
    direction: string;
}

export interface QualifierLevel {
    leftNumber: number;
    rightNumber: number;
    comparerType: number;
}

export interface Eligibility {
    AssignedGroups: AssignedGroups;
}

export interface AssignedGroups {
    emp: AssignedGroup[];
    rec: AssignedGroup[];
}

export interface AssignedGroup {
    BaseGroupType: number;
    GroupID: number;
    CompanyID: number;
    GroupName: string;
    Group1ID: number;
    Group2ID: number;
    Group3ID: number;
    Group4ID: number;
    Group5ID: number;
    GroupLevel: number;
}

export interface Schedule {
    StartDate: string;
    EndDate: string;
    IntervalType: IntervalType;
    Ongoing: boolean;
}

export enum IntervalType {
    Day = 0,
    Week = 1,
    Month = 2,
    Once = 3,
    Year = 4
}

export enum GameType {
    MultiplierMadness = 1,
    TopDog = 2,
    Bullseye = 3,
    Percentile = 4,
    Milestone = 5,
    Connect3 = 6,
    Blackout = 7,
    TopTeam = 8
}

export interface RankingByLogin {
    gameRewards: GameRewards;
}

export interface GameRewards {
    Rule:         Rule;
    MyRankingObj: MyRankingObj;
    Rankings:     Ranking[];
}

export interface MyRankingObj {
    MyRanking:                 number;
    MyPercentile:              number;
    TotalParticipants:         number;
    Score:                     number;
    MetricGroupInfos:          MetricGroupInfo[];
    MatchingRankLevelID:       number;
    MatchingRangeLevelID:      number;
    MatchingPercentileLevelID: number;
    HasCoinAction:             boolean;
    CoinsAmount:               number;
    HasXPAction:               boolean;
    XPAmount:                  number;
    HasBadgeAction:            boolean;
    Badges:                    Badge[];
    HasCoachingAction:         boolean;
    NeedsCoaching:             boolean;
    HasSurveyAction:           boolean;
    NeedsSurvey:               boolean;
}

export enum Name {
    CopyOfMilestoneRP1 = "Copy of Milestone-RP1",
    CopyOfMilestoneRP2 = "Copy of Milestone-RP2",
    CopyOfMilestoneRP3 = "Copy of Milestone-RP3",
    MilestoneCC1 = "Milestone CC1",
    MilestoneCC2 = "Milestone CC2",
    MilestoneCC21 = "MilestoneCC21",
    MilestoneRP1 = "Milestone-RP1",
    MilestoneRP2 = "Milestone-RP2",
    MilestoneRP3 = "Milestone-RP3",
}

export interface MetricGroupInfo {
    RuleMetricID:       number;
    AverageMetricValue: number;
    BestMetricValue:    number;
    MyMetricValue:      number;
    MyScore:            number;
    MetricID:           number;
}

export interface Ranking {
    Place:                  number;
    Name:                   string;
    ViewScore:              number;
    ActualScore:            number;
    FirstMetricActualScore: number;
    LoginID:                number;
    ImageID:                number;
    ImageTypeID:            number;
    GroupID:                number;
    GroupName:              string;
}

export type iconStatus = 'success' | 'info' | 'warning' | 'error';

export enum TooltipType {
    Q1 = 'Q1',
    Q2 = 'Q2'
}
export interface RankingByLogin {
    gameRewards: GameRewards;
}
export interface GameRewards {
    Rule:         Rule;
    MyRankingObj: MyRankingObj;
    Rankings:     Ranking[];
}
export interface MyRankingObj {
    MyRanking:                 number;
    MyPercentile:              number;
    TotalParticipants:         number;
    Score:                     number;
    MetricGroupInfos:          MetricGroupInfo[];
    MatchingRankLevelID:       number;
    MatchingRangeLevelID:      number;
    MatchingPercentileLevelID: number;
    HasCoinAction:             boolean;
    CoinsAmount:               number;
    HasXPAction:               boolean;
    XPAmount:                  number;
    HasBadgeAction:            boolean;
    Badges:                    Badge[];
    HasCoachingAction:         boolean;
    NeedsCoaching:             boolean;
    HasSurveyAction:           boolean;
    NeedsSurvey:               boolean;
}
export interface Badge {
    LevelBadgeID:   number;
    RuleLevelID:    number;
    RuleID:         number;
    CompanyID:      number;
    BadgeLevelName: null;
    ImageID:        number;
    ImagePath:      string;
    IsDeleted:      boolean;
    DateAdded:      Date;
    DateRemoved:    null;
    Timestamp:      string;
    GivenByName:    null;
    RuleType:       number;
    GameType:       number;
}
export interface MetricGroupInfo {
    RuleMetricID:       number;
    AverageMetricValue: number;
    BestMetricValue:    number;
    MyMetricValue:      number;
    MyScore:            number;
    MetricID:           number;
}
export interface Ranking {
    Place:                  number;
    Name:                   string;
    ViewScore:              number;
    ActualScore:            number;
    FirstMetricActualScore: number;
    LoginID:                number;
    ImageID:                number;
    ImageTypeID:            number;
    GroupID:                number;
    GroupName:              string;
}

export enum ComparisonType {
    GreaterThan = 1,
    LessThan = 2,
    Between = 3
}

export enum MetricDirection {
    Up = "1",
    Down = "2"
}
